module.exports = __webpack_public_path__ + "static/media/icon-action.857a1330.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/type-filters/icon-action.svg
// module id = 1584
// module chunks = 0